import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonColorsAndThemesComponent from 'webapp/components/common/colors-and-themes';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type ReportSlide from 'webapp/models-custom/report-slide';

interface Args {
	model: ReportSlide;
	onChange: () => void;
	onDuplicate: () => void;
	onRemove: () => void;
}

export default class ReportsEditorSlideSettingsTypeTextComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;
	@service('model-manager/report-slides')
	declare mmReportSlidesService: Service.ModelManager.ReportSlides;

	onChange(): void {
		this.args.onChange();
	}

	@action
	changeColor(color: string): void {
		this.args.model.color = color;
		this.onChange();
	}

	@action
	changeTheme(themeId: number): void {
		this.args.model.themeId = themeId;
		this.onChange();
	}

	@action
	openVisualSettings(): void {
		this.mmReportSlidesService.openVisualSettingsPopup(this.args.model);
	}
	<template>
		<div class="actions">

			<div class="action action-color">
				<CommonColorsAndThemesComponent
					@selectedColor={{@model.color}}
					@selectedTheme={{@model.themeId}}
					@reportSlide={{@model}}
					@onColorChange={{this.changeColor}}
					@onThemeChange={{this.changeTheme}}
				/>
			</div>

			<div class="action action-visual">
				<a {{on "click" this.openVisualSettings}}>
					<CommonUiIconComponent @name="Image" @size="sm" />
					Visual settings
				</a>
			</div>

			<div class="action action-duplicate">
				<a {{on "click" @onDuplicate}}>
					<CommonUiIconComponent @name="Copy" @size="sm" />
					Duplicate
				</a>
			</div>

			<div class="action action-delete">
				<a {{on "click" @onRemove}}>
					<CommonUiIconComponent @name="Trash" @size="sm" />
					Delete slide
				</a>
			</div>

		</div>
	</template>
}
